import React from "react";
import data from "./copywriting.json";
// import v0 from '../../../../assets/videos/0.mp4';
// import v1 from '../../../../assets/videos/1.mp4';
// import v2 from '../../../../assets/videos/2.mp4';
// import v3 from '../../../../assets/videos/3.mp4';
// import v4 from '../../../../assets/videos/4.mp4';
// import v5 from '../../../../assets/videos/5.mp4';

import "./index.scss";
import Slide from "./Slide";

// 视频被上传至FDS
const baseUrl =
  "https://cnbj3-fusion.fds.api.xiaomi.com/privacy-station-staging/video";

const v0 = `${baseUrl}/0.mp4`;
const v1 = `${baseUrl}/1.mp4`;
const v2 = `${baseUrl}/2.mp4`;
const v3 = `${baseUrl}/3.mp4`;
const v4 = `${baseUrl}/4.mp4`;

class Slides extends React.Component {
  state = {
    currentIndex: -1,
    nextIndex: 0,
    isAnimating: false,
  };

  slideInstances = [];

  collectSlideInstances = (instance) => this.slideInstances.push(instance);

  sectionRef = null;

  copywritingKey = ["公开透明", "企业责任", "用户可控", "安全保障", "法律合规"];

  videoUrls = [v0, v1, v2, v3, v4];

  mounted = true;

  render() {
    const { currentIndex } = this.state;
    return (
      <div
        ref={(el) => {
          this.sectionRef = el;
        }}
        className="Main__section Slides"
      >
        {this.copywritingKey.map((key, index) => {
          const title = this.copywritingKey[index];
          return (
            <Slide
              ref={this.collectSlideInstances}
              currentIndex={currentIndex}
              key={index}
              index={index}
              videoUrl={this.videoUrls[index]}
              title={title}
              squareText={data[title].text}
              intro={data[title].intro}
              beginSlidesWheelCallbackEnhanced={
                this.beginSlidesWheelCallbackEnhanced
              }
              beginSlidesWheelCallbackEnhancedFromBack={
                this.beginSlidesWheelCallbackEnhancedFromBack
              }
              prevSlideAnimationReversedCallback={
                this.prevSlideAnimationReversedCallback
              }
              indicateAnimationComplete={this.indicateAnimationComplete}
            />
          );
        })}
      </div>
    );
  }

  componentWillUnmount() {
    this.mounted = false;
    this.slideInstances.forEach((instance) => {
      instance.topToMidTl.kill();
      instance.bottomToMidTl.kill();
    });
    window.removeEventListener("wheel", this.handleWheel);
  }

  handleWheel = (e) => {
    if (!this.mounted) {
      return;
    }
    if (Math.abs(e.deltaY) < 3) {
      return;
    }
    if (e.deltaY === 0) {
      return;
    }

    const { isAnimating, currentIndex } = this.state;

    if (isAnimating) {
      //
    } else {
      const nextIndex = currentIndex + Math.sign(e.deltaY);
      this.setState({
        nextIndex,
        isAnimating: true,
      });
      const currentVideo = this.slideInstances[currentIndex].videoRef;
      currentVideo.pause();
      currentVideo.currentTime = 0;
      if (nextIndex > currentIndex) {
        const currentTl = this.slideInstances[currentIndex].topToMidTl;
        currentTl.reverse();
      } else {
        const currentTl = this.slideInstances[currentIndex].bottomToMidTl;
        currentTl.reverse();
      }
    }
  };

  beginSlidesWheelCallbackEnhanced = () => {
    this.setState({
      currentIndex: 0,
      isAnimating: false,
    });
    const { beginSlidesWheelCallback } = this.props;
    beginSlidesWheelCallback();
    window.addEventListener("wheel", this.handleWheel, { passive: false });
  };

  beginSlidesWheelCallbackEnhancedFromBack = () => {
    const { beginSlidesWheelCallback } = this.props;
    beginSlidesWheelCallback();
    window.addEventListener("wheel", this.handleWheel, { passive: false });
  };

  prevSlideAnimationReversedCallback = () => {
    const { currentIndex, nextIndex } = this.state;
    const { scheduledInstances } = this.props;
    if (nextIndex > currentIndex) {
      if (currentIndex === this.slideInstances.length - 1) {
        document.querySelector(".Main__section.Slides").style.visibility =
          "hidden";
        scheduledInstances[2].tl.reverse();
        window.removeEventListener("wheel", this.handleWheel);
        this.setState({
          isAnimating: false,
        });
        return;
      }
      const currentTl = this.slideInstances[nextIndex].bottomToMidTl;
      currentTl.restart();
    } else {
      // 上滑
      // eslint-disable-next-line no-lonely-if
      if (currentIndex === 0) {
        document.querySelector(".Main__section.Slides").style.visibility =
          "hidden";
        scheduledInstances[0].tl.reverse();
        window.removeEventListener("wheel", this.handleWheel);
        this.setState({
          isAnimating: false,
        });
      } else {
        const currentTl = this.slideInstances[nextIndex].topToMidTl;
        currentTl.restart();
      }
    }
  };

  indicateAnimationComplete = () => {
    this.setState((state) => ({
      currentIndex: state.nextIndex,
      isAnimating: false,
    }));
  };
}

export default Slides;
